import { Row, Col, Card, CardBody } from "reactstrap";

// Kartu ringkasan statistik hasil audit.
const TryoutAIAuditStats = ({ statistics }) => {
  if (!statistics) return null;

  const totalQuestions = Number(statistics.total_questions ?? 0);
  const totalAudited = Number(statistics.total_audited ?? 0);
  const completionPercent = totalQuestions > 0 ? Math.round((totalAudited / totalQuestions) * 100) : 0;

  const cards = [
    { value: statistics.total_questions ?? 0, label: "Total Soal", accent: "#f8fbff", border: "#dbeafe" },
    { value: statistics.total_audited ?? 0, label: "Sudah Diaudit", accent: "#eef8ff", border: "#bfdbfe" },
    { value: statistics.total_with_issue ?? 0, label: "Ditemukan Masalah", accent: "#fff8ef", border: "#fde68a" },
    { value: statistics.total_without_issue ?? 0, label: "Tidak Ada Masalah", accent: "#f1fdf5", border: "#bbf7d0" },
    { value: statistics.total_missing ?? 0, label: "Belum Diaudit", accent: "#fff5f5", border: "#fecaca" },
    { value: statistics.total_solved ?? 0, label: "Sudah Diselesaikan", accent: "#f2fcf4", border: "#bbf7d0" },
    { value: statistics.total_unsolved ?? 0, label: "Belum Diselesaikan", accent: "#fff9eb", border: "#fde68a" },
  ];

  return (
    <div className="mb-4">
      <div className="d-flex flex-column flex-lg-row justify-content-between align-items-start gap-2 mb-3">
        <div>
          <h6 className="mb-1 fw-semibold">Ringkasan audit</h6>
          <small className="text-muted">Status pengerjaan dan temuan utama diperbarui otomatis.</small>
        </div>
        <div className="rounded-pill border px-3 py-2 small text-muted bg-white">
          {totalAudited}/{totalQuestions} soal telah diaudit
        </div>
      </div>

      <div className="rounded-4 border bg-white p-3 mb-3" style={{ borderColor: "#e4ebf7" }}>
        <div className="d-flex justify-content-between align-items-center small mb-2">
          <span className="fw-semibold text-dark">Cakupan audit</span>
          <span className="text-muted">{completionPercent}%</span>
        </div>
        <div className="progress rounded-pill" style={{ height: 8, background: "#eef2ff" }}>
          <div
            className="progress-bar"
            style={{
              width: `${completionPercent}%`,
              background: "linear-gradient(90deg, #2563eb 0%, #60a5fa 100%)",
            }}
          />
        </div>
      </div>

      <Row className="g-3">
        {cards.map((card) => (
          <Col xs="6" sm="4" md="3" key={card.label}>
            <Card
              className="h-100 border-0 rounded-4"
              style={{
                border: `1px solid ${card.border}`,
                boxShadow: "0 10px 24px rgba(15, 23, 42, 0.04)",
              }}
            >
              <CardBody
                className="p-3"
                style={{ background: `linear-gradient(135deg, ${card.accent} 0%, #ffffff 100%)` }}
              >
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    <div className="h4 mb-1 fw-bold text-dark">{card.value}</div>
                    <small className="text-muted d-block">{card.label}</small>
                  </div>
                  <span
                    className="rounded-circle"
                    style={{ width: 10, height: 10, background: card.border, flexShrink: 0 }}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default TryoutAIAuditStats;
